<template>
  <PageWrapper
    :active-section="SECTION_COMMUNITY"
    :active-page="PAGE_REFER_AND_EARN"
    title="Refer & Earn"
    sub-title=""
    :breadcrumbs="breadcrumbs"
    page-name="Refer and Earn"
    align="center"
    width="full"
  >
    <SmartFeed
      :source="useReferAndEarnPublicationFeedStore"
      default-entity-size="small"
      default-feed-layout="grid"
    />
  </PageWrapper>
</template>

<script>
import PageWrapper from "@/components/PageWrapper";
import SmartFeed from "SmartFeed/components/SmartFeedV2";
import { SECTION_COMMUNITY, PAGE_REFER_AND_EARN } from "@/constants/nav-constants";
import { useReferAndEarnPublicationFeedStore } from "SmartFeed/stores/feed/refer-and-earn-publication-feed-store";

export default {
  name: "ReferAndEarn",
  components: {
    PageWrapper,
    SmartFeed,
  },
  data() {
    return {
      SECTION_COMMUNITY,
      PAGE_REFER_AND_EARN,
    };
  },
  computed: {
    breadcrumbs() {
      return [
        { url: "/", label: "Home" },
        { url: "/community", label: "Community" },
      ];
    },
  },
  methods: { useReferAndEarnPublicationFeedStore },
};
</script>
